import { ManageQueuedChanges } from './ManageQueuedChanges'

export const CommitChanges = (props) => {
  return <ManageQueuedChanges mode='Commit' {...props} />
}
